import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import { SpacerVertical } from '@klarna/bubble-ui';

import { translator } from 'mage-i18n';
import { defaultContainerPropTypes, Alert } from 'moet-core';
import { ContainerTemplate, StakeholderSummary } from '@/components';
import { withCapabilityBeforeNext } from '@/flow/common';
import { getSummaryStakeholders, isRecollectionMerchant } from '@/selectors/merchant/recollection';
import { merchantRegion } from '@/selectors/merchant';
import { CAPS } from '@/constants';

const tPrefix = 'products-fe.containers.recollection_overview';

export class Confirmation extends React.Component {
  constructor(props) {
    super(props);

    const { stakeholders } = props;

    this.state = { stakeholderCardIsExpanded: Array(stakeholders.length).fill(true) };
  }

  onExpandStakeholderCard(index) {
    const { stakeholderCardIsExpanded } = this.state;
    const expandedCard = [...stakeholderCardIsExpanded];
    expandedCard[index] = !stakeholderCardIsExpanded[index];
    this.setState({ stakeholderCardIsExpanded: expandedCard });
  }

  render() {
    const { stakeholderCardIsExpanded } = this.state;
    const { t, region, stakeholders, error, isRecollectionMerchant } = this.props;

    const stakeholdersFragment = (
      <>
        {stakeholders &&
          stakeholders.map((stakeholder, index) => (
            <React.Fragment key={`recollection-confirmation-stakeholders-${index}`}>
              <StakeholderSummary
                merchantCountry=""
                stakeholder={stakeholder}
                onExpand={() => this.onExpandStakeholderCard(index)}
                isExpanded={stakeholderCardIsExpanded[index]}
                t={t}
                title={t(`${tPrefix}.stakeholder`, {
                  index: stakeholders.length > 1 ? index + 1 : '',
                })}
                region={region}
                isRecollectionMerchant={isRecollectionMerchant}
              />
              <SpacerVertical small />
            </React.Fragment>
          ))}
      </>
    );
    return (
      <ContainerTemplate
        title={t(`${tPrefix}.title`)}
        subtitle={t(`${tPrefix}.subtitle`)}
        contentWidth={4}
        error={error}
      >
        <SpacerVertical extraSmall />
        <Alert type="success" content={t(`${tPrefix}.notice`)} />
        <SpacerVertical medium />
        {stakeholdersFragment}
      </ContainerTemplate>
    );
  }
}

Confirmation.propTypes = {
  ...defaultContainerPropTypes,
  isRecollectionMerchant: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  error: PropTypes.object,
};

export default compose(
  connect(state => ({
    t: translator(state),
    stakeholders: getSummaryStakeholders(state),
    region: merchantRegion(state),
    isRecollectionMerchant: isRecollectionMerchant(state),
  })),
  withCapabilityBeforeNext({ cap: CAPS.V2_MERCHANTS_RECOLLECTION_POST }),
)(Confirmation);
